module.exports = __webpack_public_path__ + "static/media/banner-bg-inicio-julho-mobile.1953983a.png";